import { Reducer, AnyAction } from 'redux';
import { FilterActionTypes, FilterState } from './types';
import { AppConfig } from './../../appConfig';

const initialState: FilterState = {
	defaultCountry: null,
	selectedCountry: null,
	enteredVin: null,
	selectedVehicleMarketEntry: null,
	selectedInfotaiment: null,
	selectedModel: null,
	selectedProductionInterval: null,
	isCountryManuallySubmitted: false,
	dataFilter: {
		ImporterBid: AppConfig.GlobalSetting.Bid,
		Culture: AppConfig.GlobalSetting.Culture,
		CountryCode: null,
		EnteredVin: null,
		VehicleMarketEntryCode: null,
		FamilyCode: null,
		InfotainmentCode: null,
		ProductionFromCode: null,
		ProductionToCode: null
	}
}

const reducer: Reducer<FilterState> = (state = initialState, action) => {
	switch (action.type) {
		case FilterActionTypes.APPLY_CountryFilter: {
			return {
				...state,
				defaultCountry: action.payload && action.payload.selectedCountry && action.payload.isDefault ? action.payload.selectedCountry : state.defaultCountry,
				selectedCountry: action.payload && action.payload.selectedCountry ? action.payload.selectedCountry : initialState.selectedCountry,
				isCountryManuallySubmitted: action.payload && action.payload.isManuallySubmitted,
				dataFilter: {
					...state.dataFilter,
					CountryCode: action.payload && action.payload.selectedCountry ? action.payload.selectedCountry.Code : initialState.dataFilter.CountryCode
				}
			}
		}
		case FilterActionTypes.APPLY_WizardFilter: {
			return {
				...state,
				enteredVin: action.payload ? action.payload.enteredVin : initialState.enteredVin,
				selectedVehicleMarketEntry: action.payload ? action.payload.selectedVehicleMarketEntry : initialState.selectedVehicleMarketEntry,
				selectedModel: action.payload ? action.payload.selectedModel : initialState.selectedModel,
				selectedInfotaiment: action.payload ? action.payload.selectedInfotaiment : initialState.selectedInfotaiment,
				selectedProductionInterval: action.payload ? action.payload.selectedProductionInterval : initialState.selectedProductionInterval,
				dataFilter: {
					...state.dataFilter,
					EnteredVin: action.payload && action.payload.enteredVin ? action.payload.enteredVin : initialState.dataFilter.EnteredVin,
					VehicleMarketEntryCode: action.payload && action.payload.selectedVehicleMarketEntry ? action.payload.selectedVehicleMarketEntry.Code : initialState.dataFilter.VehicleMarketEntryCode,
					FamilyCode: action.payload && action.payload.selectedModel ? action.payload.selectedModel.Code : initialState.dataFilter.FamilyCode,
					InfotainmentCode: action.payload && action.payload.selectedInfotaiment ? action.payload.selectedInfotaiment.Code : initialState.dataFilter.InfotainmentCode,
					ProductionFromCode: action.payload && action.payload.selectedProductionInterval && action.payload.selectedProductionInterval.From
						? action.payload.selectedProductionInterval.From.Code : initialState.dataFilter.ProductionFromCode,
					ProductionToCode: action.payload && action.payload.selectedProductionInterval && action.payload.selectedProductionInterval.To
						? action.payload.selectedProductionInterval.To.Code : initialState.dataFilter.ProductionToCode
				}
			}
		}
		case FilterActionTypes.RESET_All: {
			return {
				...state,
				selectedCountry: state.defaultCountry,
				selectedInfotaiment: initialState.selectedInfotaiment,
				enteredVin: initialState.enteredVin,
				selectedVehicleMarketEntry: initialState.selectedVehicleMarketEntry,
				selectedModel: initialState.selectedModel,
				selectedProductionInterval: initialState.selectedProductionInterval,
				dataFilter: {
					ImporterBid: AppConfig.GlobalSetting.Bid,
					Culture: AppConfig.GlobalSetting.Culture,
					EnteredVin: initialState.dataFilter.EnteredVin,
					VehicleMarketEntryCode: initialState.dataFilter.VehicleMarketEntryCode,
					CountryCode: state.defaultCountry ? state.defaultCountry.Code : initialState.dataFilter.CountryCode,
					FamilyCode: initialState.dataFilter.FamilyCode,
					InfotainmentCode: initialState.dataFilter.InfotainmentCode,
					ProductionFromCode: initialState.dataFilter.ProductionFromCode,
					ProductionToCode: initialState.dataFilter.ProductionToCode
				}
			}
		}
		default: {
			return state
		}
	}
}

export { reducer as filterReducer }
